export default __webpack_public_path__ + "static/media/pc-build-badge.972c8910.svg";